// removed by extract-text-webpack-plugin
module.exports = {"titleBox":"titleBox--4f73f"};